// Mirrors the CHECK-constraint enums in db/migrations/0001_init.sql. Keep these
// in sync with the schema — the DB will reject out-of-set values.

export const PIPELINE_STAGES = [
  "CONCEPT",
  "PROMPT",
  "AUDIO",
  "ASSETS",
  "MASTER",
  "RELEASE",
] as const;
export type PipelineStage = (typeof PIPELINE_STAGES)[number];

export const TRACK_SOURCES = ["manual", "soundcloud"] as const;

export const CONCEPT_STATUSES = ["DRAFT", "READY"] as const;

export const PROMPT_STATUSES = ["DRAFT", "GENERATED", "FINAL"] as const;

export const GENERATION_STATUSES = [
  "PENDING",
  "GENERATED",
  "SELECTED",
  "REJECTED",
] as const;

export const ASSET_TYPES = ["COVER_ART", "VIDEO", "LOOP", "OTHER"] as const;
export const ASSET_STATUSES = ["PENDING", "IN_PROGRESS", "DONE"] as const;

export const MASTER_STATUSES = ["PENDING", "PRE_MASTER", "MASTERED"] as const;

export const RELEASE_STATUSES = ["PENDING", "RELEASED"] as const;

// Stage badge colors (Forge Design System V2 tokens) for the pipeline board.
export const STAGE_COLOR: Record<PipelineStage, string> = {
  CONCEPT: "var(--cool-smoke)",
  PROMPT: "var(--ash)",
  AUDIO: "var(--gold)",
  ASSETS: "var(--amber)",
  MASTER: "var(--molten)",
  RELEASE: "var(--ember)",
};
